import { render, staticRenderFns } from "./EducationTheoryLessonPreview.vue?vue&type=template&id=417914e2"
import script from "./EducationTheoryLessonPreview.vue?vue&type=script&lang=ts"
export * from "./EducationTheoryLessonPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports